import { styled, css } from 'styled-components';
import { animationDuration } from '../drawerConsts';
import { dontForwardProps } from '../../../util';
export const DrawerBackdrop = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-d9tkmg-0"
})(["position:absolute;top:0;left:0;bottom:0;right:0;height:100vh;width:100vw;background:rgba(0,0,0,0.5);transition:opacity ", " ease-in-out;will-change:opacity;", ""], animationDuration, ({
  isOpen
}) => !isOpen && css(["opacity:0;"]));